import React from 'react';
import LocationDetails from '../../components/LocationDetails';

const GhatDetails = ({ routeData }) => {
  return (
    <LocationDetails
      routeData={routeData}
      locationType="Ghat"
      baseUrl="/ghats"
      idParamName="ghatId"
    />
  );
};

export default GhatDetails;
